// eslint-disable-next-line import/exports-last
import { AxiosError, AxiosResponse } from 'axios';

// eslint-disable-next-line import/exports-last
export const fetcher = async <T>(promise: Promise<T>) => {
	try {
		const data = await promise;

		return {
			data: data,
		};
	} catch (error: any) {
		return {
			error,
		};
	}
};

const isTrue = (value: any) => value === true || value === 'true';
const isFalse = (value: any) => value === false || value === 'false';
const isBlob = (value: any) => value instanceof Blob;
const isFile = (value: any) => value instanceof File;
const isObject = (value: any) => value && typeof value === 'object';

export const serializeFormData = (obj: Record<string, any>) => {
	if (!isObject(obj)) {
		return obj;
	}

	for (const key in obj) {
		const value = obj[key];

		if (isTrue(value) || isFalse(value)) {
			obj[key] = isTrue(value) ? 1 : 0;
		} else if (isObject(value) && !isBlob(value) && !isFile(value)) {
			obj[key] = serializeFormData(value);
		}
	}

	return obj;
};

export const getDataFromAxios = async (responseOrError: AxiosResponse | AxiosError) => {
	const response = (responseOrError as AxiosError)?.response || responseOrError as AxiosResponse;
	const data: Blob = response?.data as any;
	
	if (data && typeof data === 'object' && !((data as any) instanceof Blob)) {
		return data;
	}
	
	const stringData = data ? await data?.text() || '{}' : '{}';
	
	return JSON.parse(stringData);
};
